export default __webpack_public_path__ + "static/media/nov1_challenge.ca122ba6.svg";